<template functional>
    <div
        class="VLabel noselect"
        :class="[`VLabel_${props.action}`,{disabled:props.disabled}]"
        :style="[props.action ==='remove'  || props.action ==='simple'? {background:props.color} : {border:`2px solid
        ${props.color}`},{fontWeight:props.fontWeight}]"
        @click="listeners.click ? { click: listeners.click($event) } : null"
        v-on="listeners.mouseover ? { mouseover: listeners.mouseover } : null"
    >
        <slot name="action">
        <span
            class="VLabel-action"
            :class="props.action"
            v-if="props.action !== 'simple'"
        >
            +
        </span>
        </slot>
        <slot>
        
        </slot>
    </div>
</template>

<script>
    export default {
        name: 'VLabel',
        props: {
            color: {
                type: String,
                default: '',
                required: false,
            },
            fontWeight: {
                type: Number,
                default: 400,
                required: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            action: {
                type: String,
                default: 'remove',
                validator: function (value) {
                    return ['add', 'remove', 'simple'].includes(value);
                },
            },
        },
        
    };
</script>

<style
    scoped
    lang="scss"
>
    
    .VLabel {
        padding: 6px 13px;
        border-radius: 5px;
        display: inline-block;
        cursor: pointer;
        position: relative;
        padding-left: 25px;
        color: #FFFFFF;
        
        &-action {
            display: inline-block;
            font-size: 15px;
            line-height: 0;
            font-weight: bold;
            position: absolute;
            top: 8px;
            left: 9px;
        }
        
        &_add {
            color: $dark-blue-color;
        }
    }
    
    .remove {
        transform: translate(0px, 5px) rotate(45deg);
    }
    
    .add {
        transform: translate(0px, 5px);
    }
</style>